// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

// Import pages
import Home from './pages/home';
import Terms from './pages/terms';
import PrivacyPolicy from './pages/privacy';
//import NotFound from './pages/NotFound';

// Import structured data components
import { 
  MobileAppStructuredData, 
  OrganizationStructuredData 
} from './components/StructuredData';

// Main App component with Helmet Provider for metadata
function App() {
  return (
    <HelmetProvider>
      <div className="app">
        {/* Add global structured data */}
        <MobileAppStructuredData />
        <OrganizationStructuredData />
        
        <Router>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
          </Routes>
        </Router>
      </div>
    </HelmetProvider>
  );
}

export default App;